







































































































































































































import {
  addDays,
  anyToDate,
  differenceInDays,
  formatDate,
  isFuture,
  isToday,
  startOfDay,
} from 'vtils/date'
import {
  apiCommoditySkuStockWriteOffList,
  ApiCommoditySkuStockWriteOffListResponse,
  apiGroupBuyingTradePreOrder,
  ApiGroupBuyingTradePreOrderRequest,
  apiOrderExchangeGoodsExchangeGoodsPreOrder,
  ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest,
  apiTradeGeneralTradePreOrder,
  ApiTradeGeneralTradePreOrderRequest,
  apiTradeSecKillTradeSeckillConfirmResult,
  apiTradeSecKillTradeSeckillPreOrder,
  ApiTradeSecKillTradeSeckillPreOrderRequest,
} from '@/api'
import { bookGoodsModelProvider } from '../model'
import { computed, nextTick, ref, watch } from '@vue/composition-api'
import { currentSaleChannelId } from '@/channel'

import { AliyunCaptcha } from '@/sdk/aliyun_captcha'
import { defineClassComponent, useQuery } from '@/hooks'
import { getDisplayPrice, requiredDeep, submit, Track } from '@/utils'
import { globalModel } from '@/model'
import { ImagePreview } from 'vant'
import { keyBy, loopUntil, orderBy, range } from 'vtils'
import { navigateBackOrTo, navigateTo } from '@/router'

export default defineClassComponent<{
  isShowSkuPicker?: boolean
  isShowSkuPickerFromGroupBuying?: boolean
  groupBuyingOrderId?: string
  handleSkuPickerConfirm?: (value: any) => any
}>(
  {
    props: [
      'isShowSkuPicker',
      'isShowSkuPickerFromGroupBuying',
      'groupBuyingOrderId',
      'handleSkuPickerConfirm',
    ],
  },
  ({ props, ctx }) =>
    class {
      constructor() {
        if (props.isShowSkuPicker) {
          watch(
            () => [this.showSkuPicker.value, this.showDatePicker.value],
            () => {
              if (!this.showSkuPicker.value && !this.showDatePicker.value) {
                ctx.$emit('closeSkuPicker')
              }
            },
          )
        }
      }

      query = useQuery<{
        goodsId: string
        exchangeCommodityId: string
        type: string
        skuId: string
        parentOrderNo: string
        onlyShowDetail: string
      }>()
      bookGoodsModel = bookGoodsModelProvider.inject()

      displayPrice = computed(() =>
        getDisplayPrice(this.bookGoodsModel.value),
      )

      seckillData = computed(() => this.bookGoodsModel.value.seckillData)

      // 秒杀信息
      seckillInfo = computed(() => this.bookGoodsModel.value.seckillInfo)

      // 兑换商品sku信息
      virtualSkuInfo = computed(
        () => this.bookGoodsModel.value.virtualSkuInfo,
      )

      showSkuPickerFromGroupBuying = ref(
        !!props.isShowSkuPickerFromGroupBuying,
      )
      showSkuPicker = ref(!!props.isShowSkuPicker)

      showDatePicker = ref(false)

      initialDate = ref<Date>()

      minDate = ref(new Date())

      maxDate = ref(addDays(new Date(), 40))

      skuData =
        ref<Record<string, ApiCommoditySkuStockWriteOffListResponse[0]>>()

      formatDate = (day: {
        date: Date
        topInfo?: string
        text: string | number
        bottomInfo?: string
        type: 'disabled' | 'selected' | ''
      }) => {
        if (day.type !== 'disabled') {
          // 开始时间逻辑
          if (
            +this.bookGoodsModel.value.isValidDay === 0 &&
            this.bookGoodsModel.value.advanceDay
          ) {
            if (
              differenceInDays(startOfDay(day.date), startOfDay(new Date())) <
              this.bookGoodsModel.value.advanceDay
            ) {
              day.type = 'disabled'
            }
          }

          const skuInfo =
            this.skuData.value![formatDate(day.date, 'yyyy-mm-dd')]
          if (!skuInfo || skuInfo.surplusStock === 0) {
            day.type = 'disabled'
          }
          if (skuInfo) {
            day.bottomInfo = `￥${skuInfo.sellPrice}`
          }
        }
        return day
      }

      handleMerchantClick = () => {
        navigateBackOrTo('BookIndex', {
          martId: this.bookGoodsModel.value.merchantId,
        })
      }

      handleSkuImageClick = (url: string) => {
        ImagePreview({
          images: [url],
          startPosition: 0,
        })
      }

      handleBuyClick = async () => {
        if (this.query.type === 'exchange') {
          if (!this.virtualSkuInfo.value.cutStock) {
            return
          }
          const preOrderRequestData: ApiTradeGeneralTradePreOrderRequest = {
            preOrderType: 2 as any,
            skuInfo: [
              {
                commodityId: this.bookGoodsModel.value.goodsId,
                count: 1,
                sellChannelId: currentSaleChannelId,
                skuId: this.query.skuId,
              },
            ],
          }
          const preOrderRequestData1: ApiOrderExchangeGoodsExchangeGoodsPreOrderRequest =
            {
              commodityId: this.bookGoodsModel.value.goodsId,
              exchangeCommodityId: this.query.exchangeCommodityId,
              parentOrderNo: this.query.parentOrderNo,
              skuId: this.query.skuId,
            }

          const res = await apiOrderExchangeGoodsExchangeGoodsPreOrder(
            preOrderRequestData1,
          )

          nextTick(() => {
            navigateTo('BookOrderPlace', {
              type: 'normal',
              sourceType: this.query.type,
              preOrderRequestData: JSON.stringify(preOrderRequestData),
              preOrderRequestData1: JSON.stringify(preOrderRequestData1),
              preOrderResponseData: JSON.stringify(res),
            })
          })
        } else {
          this.showSkuPickerFromGroupBuying.value = false
          this.showSkuPicker.value = true
        }
      }

      handleGroupBuyingClick = () => {
        this.showSkuPickerFromGroupBuying.value = true
        this.showSkuPicker.value = true
      }

      handleBuyConfirm = () => {
        if (
          this.bookGoodsModel.value.skuList[
            this.bookGoodsModel.value.skuIndex
          ].stockType === 3
        ) {
          submit(async $ => {
            $.start()
            const skuDetail = await apiCommoditySkuStockWriteOffList({
              commodityId: this.bookGoodsModel.value.goodsId,
              skuId:
                this.bookGoodsModel.value.skuList[
                  this.bookGoodsModel.value.skuIndex
                ].skuId,
            }).then(requiredDeep)
            this.skuData.value = keyBy(skuDetail, item =>
              formatDate(anyToDate(item.stockDate), 'yyyy-mm-dd'),
            )
            this.initialDate.value = anyToDate(
              orderBy(
                skuDetail,
                item => anyToDate(item.stockDate).getTime(),
                'asc',
              ).find(
                item =>
                  isToday(anyToDate(item.stockDate)) ||
                  isFuture(anyToDate(item.stockDate)),
              )!.stockDate,
            )
            this.showDatePicker.value = true
          })
        } else {
          this.handleDateConfirm()
        }
      }

      handleDateConfirm = async (date?: Date) => {
        if (props.handleSkuPickerConfirm) {
          props.handleSkuPickerConfirm({
            goodsId: this.bookGoodsModel.value.commodityId,
            skuId:
              this.bookGoodsModel.value.skuList[
                this.bookGoodsModel.value.skuIndex
              ].skuId,
            buyCount: 1,
            date: date,
          })
          return
        }

        // 验证码
        await AliyunCaptcha.showIfNeeded({
          goodsId: this.bookGoodsModel.value.commodityId,
        })

        Track.pushEvent({
          type: 'click',
          name: '立即购买',
          id: 'JiaGou',
          extra: {
            commodity_id: this.bookGoodsModel.value.commodityId,
            commodity_name: this.bookGoodsModel.value.commodityTitle,
            commodity_tag: '',
            original_price: this.bookGoodsModel.value.dashPrice,
            present_price: this.bookGoodsModel.value.lowestPrice,
            discount_price:
              this.bookGoodsModel.value.dashPrice -
              this.bookGoodsModel.value.lowestPrice,
            store_id: this.bookGoodsModel.value.merchantId,
            store_name: this.bookGoodsModel.value.merchantName,
            sku_id:
              this.bookGoodsModel.value.skuList[
                this.bookGoodsModel.value.skuIndex
              ].skuId,
            sku_name:
              this.bookGoodsModel.value.skuList[
                this.bookGoodsModel.value.skuIndex
              ].specName,
            additional_purchase_type: '立即购买',
          },
        })
        submit(async $ => {
          $.start()
          if (this.showSkuPickerFromGroupBuying.value) {
            const preOrderRequestData: ApiGroupBuyingTradePreOrderRequest = {
              activityId:
                this.bookGoodsModel.value.marketingData.groupBuying
                  .activityId,
              groupOrderId: props.groupBuyingOrderId || '',
              preOrderType: 2 as any,
              skuInfo: [
                {
                  activityId:
                    this.bookGoodsModel.value.marketingData.groupBuying
                      .activityId,
                  commodityId: this.bookGoodsModel.value.commodityId,
                  count: 1,
                  skuId:
                    this.bookGoodsModel.value.skuList[
                      this.bookGoodsModel.value.skuIndex
                    ].skuId,
                  sellChannelId: currentSaleChannelId,
                },
              ],
            }
            const res = await apiGroupBuyingTradePreOrder(preOrderRequestData)
            this.showSkuPicker.value = false
            this.showDatePicker.value = false
            nextTick(() => {
              // 弹窗进行了路由改造，直接 redirect 过去即可
              navigateTo('BookOrderPlace', {
                type: 'groupBuying',
                preOrderRequestData: JSON.stringify(preOrderRequestData),
                preOrderResponseData: JSON.stringify(res),
              })
            })
          } else if (this.bookGoodsModel.value.isSeckill) {
            const preOrderRequestData: ApiTradeSecKillTradeSeckillPreOrderRequest =
              {
                activityId: this.seckillData.value.activityId,
                preOrderType: 3 as any,
                sessionId: this.seckillData.value.sessionId,
                skuInfo: [
                  {
                    activityId: this.seckillData.value.activityId,
                    commodityId:
                      this.seckillData.value.commodityInfo.commodityId,
                    count: 1,
                    skuId:
                      this.bookGoodsModel.value.skuList[
                        this.bookGoodsModel.value.skuIndex
                      ].skuId,
                  },
                ],
              }
            await apiTradeSecKillTradeSeckillPreOrder(preOrderRequestData)
            const res = await loopUntil(
              () => apiTradeSecKillTradeSeckillConfirmResult(),
              res => res.confirmState !== 0,
              {
                retryDelay: range(100, 500, 10),
              },
            )
            if (res.confirmState === 2) return $.fail(res.msg!)
            const data = res.result
            this.showSkuPicker.value = false
            this.showDatePicker.value = false
            nextTick(() => {
              navigateTo('BookOrderPlace', {
                preOrderRequestData: JSON.stringify(preOrderRequestData),
                preOrderResponseData: JSON.stringify(data),
              })
            })
          } else {
            const preOrderRequestData: ApiTradeGeneralTradePreOrderRequest = {
              captchaToken: AliyunCaptcha.getToken(),
              preOrderType: 2 as any,
              deviceId: globalModel.state.currentDeviceId,
              tvHotelId: globalModel.state.tvHotelId,
              tvHotelRoomNo: globalModel.state.tvHotelRoomNo,
              skuInfo: [
                {
                  commodityId: this.bookGoodsModel.value.goodsId,
                  count: 1,
                  sellChannelId: currentSaleChannelId,
                  skuId:
                    this.bookGoodsModel.value.skuList[
                      this.bookGoodsModel.value.skuIndex
                    ].skuId,
                  stockDate: date
                    ? formatDate(date, 'yyyy-mm-dd')
                    : undefined,
                },
              ],
            } as any
            const res = await apiTradeGeneralTradePreOrder(
              preOrderRequestData,
            )
            this.showSkuPicker.value = false
            this.showDatePicker.value = false
            nextTick(() => {
              navigateTo('BookOrderPlace', {
                type: this.bookGoodsModel.value.isDcd ? 'dcd' : 'normal',
                preOrderRequestData: JSON.stringify(preOrderRequestData),
                preOrderResponseData: JSON.stringify(res),
              })
            })
          }
        })
      }
    },
)
